import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { Checkbox, CHECKBOX_SIZE } from '../../../../../../../Checkbox'
import {
  FormikField,
  getFormikCheckboxFieldErrorProps,
  getFormikCheckboxFieldValueProps,
} from '../../../../../../../Formik'
import {
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_ALL_EMPLOYEES,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_TV_SCREENS,
} from '../../../RecipientsField.constants'

import * as styles from '../../CustomizeRecipientAudienceModal.module.css'

function AudienceCheckboxFields({ ticker }) {
  const { t } = useTranslation()

  return (
    <>
      <FormikField
        Component={Checkbox}
        Field={Fragment}
        getErrorProps={getFormikCheckboxFieldErrorProps}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t('Newsboard.RecipientsTvScreensCheckboxLabelKey')}
        labelClassName={styles.checkboxLabel}
        name={NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_TV_SCREENS}
        size={CHECKBOX_SIZE.small}
      />
      {!ticker ? (
        <FormikField
          Component={Checkbox}
          Field={Fragment}
          getErrorProps={getFormikCheckboxFieldErrorProps}
          getValueProps={getFormikCheckboxFieldValueProps}
          label={t('Newsboard.RecipientsAllEmployesCheckboxLabelKey')}
          labelClassName={styles.checkboxLabel}
          name={NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_ALL_EMPLOYEES}
          size={CHECKBOX_SIZE.small}
        />
      ) : null}
    </>
  )
}

export default AudienceCheckboxFields
